var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 281,
    height: 268.786,
    viewBox: "0 0 281 268.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-163.255 -172.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M334.166,240.222a73.3,73.3,0,1,0,0,103.668A73.262,73.262,0,0,0,334.166,240.222Zm-8.637,95.029a61.087,61.087,0,1,1,0-86.391A61.054,61.054,0,0,1,325.529,335.251Z",
    transform: "translate(-15.555 -15.696)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M370.008,273.47a6.109,6.109,0,0,0-8.64,8.64,39.537,39.537,0,0,1,0,55.847,6.109,6.109,0,0,0,8.64,8.64,51.775,51.775,0,0,0,0-73.129Z",
    transform: "translate(-66.666 -33.676)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M218.587,505.5a18.327,18.327,0,1,0,18.327,18.327A18.348,18.348,0,0,0,218.587,505.5Zm0,24.433a6.109,6.109,0,1,1,6.109-6.109A6.115,6.115,0,0,1,218.587,529.933Z",
    transform: "translate(-12.566 -113.074)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M520.686,276.882a24.436,24.436,0,1,0-24.436-24.436A24.463,24.463,0,0,0,520.686,276.882Zm0-36.654a12.218,12.218,0,1,1-12.218,12.218A12.232,12.232,0,0,1,520.686,240.228Z",
    transform: "translate(-113.075 -18.846)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M573.208,335.859a6.109,6.109,0,1,1-6.109-6.109,6.11,6.11,0,0,1,6.109,6.109",
    transform: "translate(-135.059 -53.394)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M526.958,391.359a6.109,6.109,0,1,1-6.109-6.109,6.108,6.108,0,0,1,6.109,6.109",
    transform: "translate(-119.354 -72.24)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M462.218,178.619a6.109,6.109,0,1,1-6.109-6.109,6.108,6.108,0,0,1,6.109,6.109",
    transform: "translate(-97.37 0)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M184.728,187.869a6.109,6.109,0,1,1-6.109-6.109,6.108,6.108,0,0,1,6.109,6.109",
    transform: "translate(-3.143 -3.141)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M193.978,465.359a6.109,6.109,0,1,1-6.109-6.109,6.108,6.108,0,0,1,6.109,6.109",
    transform: "translate(-6.284 -97.369)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M341.969,539.36a6.108,6.108,0,1,1-6.106-6.106,6.108,6.108,0,0,1,6.106,6.106",
    transform: "translate(-56.538 -122.498)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M438.149,429.082H424.731a30.582,30.582,0,0,0-2.456-40.41l-63.7-63.7a103.782,103.782,0,1,0-43.2,43.194L376.3,429.082l-60.324,0a6.109,6.109,0,1,0,0,12.218H438.146a6.109,6.109,0,1,0,0-12.218Zm-24.51-5.854a18.314,18.314,0,0,1-25.917,0l-34.556-34.556,25.917-25.917,34.556,34.556A18.345,18.345,0,0,1,413.638,423.228Zm-73.433-47.515L366.122,349.8l4.319,4.319-25.917,25.917Zm-26.881-20.4a91.625,91.625,0,1,1,32.4-32.4,6.107,6.107,0,0,0,.939,7.425l10.817,10.817-25.917,25.917-10.817-10.817a6.108,6.108,0,0,0-7.425-.939Z",
    transform: "translate(0 -0.001)",
    fill: "#d0d2d5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage404);
export default __webpack_public_path__ + "static/media/page404.a7be2ba15dc0fcfc7595670702d9384e.svg";
export { ForwardRef as ReactComponent };